import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { updateIPRDiff, updateTMTDiff } from '../../../redux/actions/wasm_viewer/wasm_viewer';
import { getWasmViewerState } from '../../../redux/selectors/wasm_viewer';
import { getIPRAndTMTTablesDifference } from '../wasm_controller/wasm_controller';
import { getCaseStages } from '../../../redux/reducers/common/common_case_details';

export const withIprAndTmtChanges = (WrappedComponent) => {
  const Wrapper = (props) => {
    const { updateIPRDiff, updateTMTDiff, editingPlan, isRevising, caseStages } = props;

    const handleFetchIRPAndTMTChanges = () => {
      // changes are a revision-time concept: without an editing plan there are no changes
      if (!isRevising) {
        updateIPRDiff({});
        updateTMTDiff({});
        return;
      }
      const { ipr, tmt } = getIPRAndTMTTablesDifference(editingPlan, caseStages.idealStage);
      updateIPRDiff(ipr);
      updateTMTDiff(tmt);
    };

    return <WrappedComponent {...props} onFetchIPRAndTMTChanges={handleFetchIRPAndTMTChanges} />;
  };

  const mapStateToProps = (state) => {
    const wasmViewerState = getWasmViewerState(state);
    return {
      treatmentPlanStage: wasmViewerState.step,
      activeTreatmentPlan: wasmViewerState.active_treatment_plan,
      editingPlan: wasmViewerState.editingPlan,
      isRevising: wasmViewerState.is_revising,
      caseStages: getCaseStages(state),
    };
  };

  const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
      {
        updateIPRDiff: updateIPRDiff,
        updateTMTDiff: updateTMTDiff,
      },
      dispatch,
    );

  return connect(mapStateToProps, mapDispatchToProps)(Wrapper);
};
